import { withLogs } from '@core';

import { apiClient, ApiConfig } from '../apiClient';

export type CameraSetup = {
    id: string;
    name: string;
    view: number;
    imageWidth: number;
    imageHeight: number;
    intrinsics: {
        fx: number;
        fy: number;
        cx: number;
        cy: number;
        width: number;
        height: number;
        distortionCoeffs: number[];
        distortionModel: 'string';
    };
    cameraInWorld: number[][];
};

export type CameraSetupResponse = {
    cameras: CameraSetup[];
    leftHanded: number;
};

export const fetchCameraSetup = withLogs(async (activityId: number) => {
    const response = await apiClient.get<CameraSetupResponse>(
        ApiConfig.path(`api/v1/activities/${activityId}/camera-setup`),
    );
    return response.data;
}, 'fetchCameraSetup');
